<template lang="pug">
  component(v-bind="linkProps(to)")
    slot
</template>

<script>
import { isExternal } from '@/javascripts/time'

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  created () {
  },
  methods: {
    isExternalLink (routePath) {
      return isExternal(routePath)
    },
    linkProps (url) {
      if (this.isExternalLink(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        is: 'router-link',
        to: url
      }
    }
  }
}
</script>
